// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1yycc","signatureBlock":"Footer_signatureBlock__2Gf2L","signature":"Footer_signature__1wgUY"};